export default __webpack_public_path__ + "static/media/sp-bti-boy.556773a4.webp";